/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
// import Toast from './sub_components/toast';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { staticContentsImagePath as BASE_IMAGE_PATH, OPERATOR_ID } from '../configs/const';
// import { ReCAPTCHA_KEY } from '../configs/const';
// import ReCAPTCHA from "react-google-recaptcha";
import Loginb2cFooter from './loginb2cFooter';
import Loginb2cHeader from './loginb2cHeader';
// import bannerList from 'https://images.staticcontents.com/banners/list.json'

let oid = OPERATOR_ID.toLowerCase()
// const recaptchaRef = React.createRef();
const hostname = window && window.location && window.location.hostname;

class Loginb2cESport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // uid: "",
            // passcode: "",
            // passVisible: false,
            // rememberMe: false,
            date: "",
            // showToast: false,
            toastMsg: "",
            toastType: "",
            showDownLoad: false,
            inMaitanence: false,
            hasUmShow: true,
            recapchaVal: "",
            isDev: false,
            desktopBanners: {},
            mobileBanners: {},
            operatorDesktopBanners: {},
            operatorMobileBanners: {},
            showPopup: false,
            showLoginPopup: false,
            selectedSection: "",
            clientWidth: document.documentElement.clientWidth,
            operator: OPERATOR_ID,
            digitainURL: '',
            host: '',
            hostdom: ''
        };
    }

    formatPickerDate(date) {
        var d = date,
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;
        year = year.toString().slice(-2)
        return [year, month, day].join('');
    }

    // showToast(msg, type) {
    //     let self = this
    //     this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
    //         setTimeout(() => {
    //             self.setState({ toastMsg: "", toastType: "", showToast: false })
    //         }, 3000);
    //     })
    // }




    hidePopup(view = "") {
        this.setState({ hasUmShow: false, [`show${view}Popup`]: false })

    }
    showPopup(view = "") {
        // debugger
        this.setState({ [`show${view}Popup`]: true })
    }
    // hideLoginPopup() {
    //     this.setState({ hasUmShow: false, showloginPopup:false })

    // }
    // showLoginPopup() {
    //     this.setState({ showloginPopup: true })
    // }
    togglePopupBetweenLoginSignup(view = "") {
        this.hidePopup(view === "" ? "Login" : "");
        this.showPopup(view);
    }
    toggleSelectedSection(name) {
        this.setState({ selectedSection: this.state.selectedSection === name ? "" : name });
    }

    componentDidMount() {
        const splited = window.location.host.split('.');
        const host = splited[splited.length - 2];
        const hostdom = splited[splited.length - 1];

        this.setState({
            host: host,
            hostdom: hostdom,
            digitainURL: `https://sport.${host}.${hostdom}/js/Partner/bootstrapper.min.js`
        }, () => {
            if (window.location.origin !== 'http://localhost:3000') {
                this.addDigitainScript();
            }
            // const operator = this.state.operator
            // let token = JSON.parse(localStorage.getItem('userAuthDetail'))
            // token = !!token ? token.token : null
            // if (!!operator && !!token) {
            //     window.localStorage.setItem("operator", operator);
            //     window.localStorage.setItem("token", token);
            //     GamesService.getDigitainSportBook().then((res) => {
            //         if (!!res && !!res.data && !!res.data.url) {
            //             this.setState({ digitainToken: res.data.url},()=>{
            //             });
            //         }
            //         this.setState({ loader: false })
            //     })
            // }
        });
    }

    addDigitainScript() {
        const script = document.createElement("script");
        script.type = 'text/javascript';
        script.src = this.state.digitainURL;
        script.async = true;
        script.id = "digiScrpt";
        let digitainToken = this.state.digitainToken;
        script.onload = function () {
            const splited = window.location.host.split('.');
            const host = splited[splited.length - 2];
            const hostdom = splited[splited.length - 1];
            var params = {
                server: `https://sport.${host}.${hostdom}/`,
                containerId: "sport_div_iframe",
                token: '',
                defaultLanguage: "en",
                // timeZone: 4,
                hashRouterDisabled: false,
                // bottomNavBar: true,
                // externalLinksOpenInside: true,
                oddsFormatList: [1, 2, 3],
                oddsFormat: 0,
                theme: "light",
                parent: [`${host}.${hostdom}`, `digitain.${host}.${hostdom}`],
                loginTrigger: function () {
                    document.getElementById('btnLoginb2cLogin').click();
                },
                // view: "european",
            };


            window['Bootstrapper'].bootIframe(params, { name: "ESport" }, { height: "900px" });
            // };
        }
        document.head.appendChild(script);
    }
    openLoginModal() {
        document.getElementById('btnLoginb2cLogin').click();
    }

    componentWillUnmount() {
        if (document.getElementById("sport_div_iframe").children.length > 0) {
            if (!!document.getElementById("digiScrpt")) {
                document.getElementById("digiScrpt").remove();
                document.getElementById("sport_div_iframe").children[0].remove();
            }
            if (!!document.getElementById("betslip-container-element")) {
                document.getElementById("betslip-container-element").remove();
            }
        }
    }
    render() {
        let settings = {
            dots: true,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 5000
        };
        return (
            <div className="radheexch radheexchlogin bg-white-login">
                <Loginb2cHeader history={this.props.history} selectedSection={this.state.selectedSection} toggleSelectedSection={(view) => this.toggleSelectedSection(view)} showSweetAlert={(options) => this.props.showSweetAlert(options)} notify={this.props.notify}></Loginb2cHeader>
                <div className='login-mar-top100'>
                    <div className='iframe-loader'>
                        <div id="sport_div_iframe">

                        </div>
                    </div>
                </div>


                <Loginb2cFooter history={this.props.history} showSweetAlert={(options) => this.props.showSweetAlert(options)} notify={this.props.notify}></Loginb2cFooter>



            </div>)
    }
}

function mapStateToProps(state) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(Loginb2cESport);